module.exports = __webpack_public_path__ + "static/media/icon-charts.1484d6cc.svg";